export default __webpack_public_path__ + "af774ac.png";